import React from 'react';

export default function UserListItemMessage({message}) 
{
    return (
        <>
            <li class="list-group-item list-group-item-action d-flex justify-content-between align-items-start">
                <div class="ms-2 me-auto">
                    <div class="fw-bold">{message}</div>
                </div>
            </li>
        </>
    );
}
